import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useCreateClientSetMutation } from "../../../services/campaignmanagement";
import { useClientSetContext } from "./ClientSetContext";

const defaultRequest = {
    name: null,
    baseSetId: null
};

const useCreateClientSet = ({ handleClose }) => {
    const { clientSets, isFetching, isError, error, refetch } = useClientSetContext();

    const [createSetTrigger] = useCreateClientSetMutation();

    const { handleSubmit, reset, control, setValue, formState: { errors } } = useForm({ defaultValues: defaultRequest });

    const createClientSet = (data) =>
        toast.promise(createSetTrigger(data).unwrap(), {
            loading: "Starting set creation...",
            success: (res) => {
                if (res?.newSetId)
                    handleClose(res.newSetId);

                return "Set created successfully!";
            },
            error: (err) => {
                console.error(err);
                handleClose();

                return "Could not create client set";
            }
        }).then(reset);

    return {
        create: handleSubmit(createClientSet),
        reset,
        control,
        setValue,
        clientSets,
        isFetching,
        isError,
        error,
        refetch,
        errors
    }
}

export default useCreateClientSet;